import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import { Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AuthService from "../../../services/auth.service";
import Modal from "react-bootstrap/Modal";
import check from "../../../picture/check.png";
import cancel from "../../../picture/cancel.png";
import AuthServiceV2 from "../../../services/auth.serviceV2";
import Static_modal from "../etc/Static_modal";
import { useLanguage } from "../../../Language/LanguageContext";
const Regisremote = () => {
  let Navigate = useNavigate();
  const { t, changeLanguage, language, fontFamily } = useLanguage();
  const [validated, setValidated] = useState(false);

  const [show, setShow] = useState(false);
  const [senddata, setSenddata] = useState(false);
  const [updatedata, setUpdatedata] = useState(false);
  const [checkopenRID, setcheckopenRID] = useState(false);
  const [spinners, setSpinners] = useState(true);
  const [updatedatasuc, setUpdatedatasuc] = useState(false);
  const [drone, setDrone] = useState([]);
  const [drone_ids, setDrone_ids] = useState("");
  const [droneid_regis, setDroneid_regis] = useState("");
  const [remoteid_sn, setRemote_sn] = useState("");
  const [remoteid_name, setRemote_name] = useState("");
  const [remoteid_man, setRemote_man] = useState("");
  const [selectRID, setSelectRID] = useState(false);
  const [waitconnect, setWaitconnect] = useState(false);
  const [datatoregis, setDatatoregis] = useState(undefined);
  const [connectiontoregis, setConnectiontoregis] = useState(undefined);
  const [connecterror, setConnecterror] = useState(false);
  const [dataerror, setDataerror] = useState();
  const [counttime, setCounttime] = useState(10);
  const [checktime, setChecktime] = useState(false);
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };

  const handleClose = () => {
    setShow(false);

    setUpdatedata(false);
    setUpdatedatasuc(false);
  };
  const handleclosereload = () => {
    setSenddata(false);
    window.location.reload(false);
  };
  const handleSend = () => {
    setShow(true);
  };
  const handlesuc = () => {
    setUpdatedatasuc(false);
    Navigate("/user/drone/statusDrone");
  };
  const handleSendsuc = () => {
    setShow(false);
    setSenddata(true);
  };
  const handleUpdate = () => {
    setUpdatedata(true);
  };
  useEffect(() => {
    let timer;

    if (checktime && counttime > 0) {
      timer = setInterval(() => {
        setCounttime((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [checktime, counttime]);
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };
  const WaitConnectRID = () => {
    console.log(datatoregis);
    const savedata = AuthServiceV2.RegisStockRemoteID(datatoregis);
    if (savedata != null) {
      savedata
        .then((res) => {
          console.log("dfsdf");
          if (res.data.status === "success") {
            setWaitconnect(false);
            setSenddata(true);
          } else {
            setWaitconnect(false);
            setConnecterror(true);
          }
          console.log(res);
        })
        .catch((error) => {
          switch (error) {
            case "Remote ID already connected":
              setTextBody("Remote ID มีผู้ครอบครองแล้ว");
              break;
            case "Cannot receive data as specified. The problem may be caused by the GPS signal of the device or the Internet signal is disrupted or MQTT server is error. Please try to reconnect.":
              setTextBody("ไม่พบ remote ID กรุณาลองใหม่อีกครั้ง");
              break;
            case "Please turn off the remote ID":
              setTextBody("กรุณาปิด remote ID และลองใหม่อีกครั้ง");
              break;
            case 'Attempt to read property "connect_status" on null':
              setTextBody("ไม่พบ serial number ในฐานข้อมูล");
              break;
            case 'Not Found!':
              setTextBody("กรุณาตรวจสอบหมายเลข Remote ID");
              break;
            default:
              console.log(error);
              setTextBody("เกิดข้อผิดพลาด");
          }
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
  };
  const handleUpdatesuc = () => {
    setUpdatedata(false);
    setCounttime(10);
    checkclose();
    // setcheckopenRID(true);
    // setTimeout(() => {
    //   setSpinners(false);
    // }, 5000);
    //setUpdatedatasuc(true);
    // regisrid();
  };
  const handleRegistremot = () => {
    // setCounttime(20);
    regisrid();
  };
  const checkclose = () => {
    setDatatoregis(undefined);
    setConnecterror(false);
    setWaitconnect(false);
    setUpdatedata(false);
    selectRID === true
      ? AuthServiceV2.registerremote(remoteid_name, remoteid_sn, "อื่นๆ", 2)
          .then((response) => {
            console.log(response);
            setUpdatedatasuc(true);
          })
          .catch((error) => {
            switch (error) {
              case "Remote ID already connected":
                setTextBody("Remote ID มีผู้ครอบครองแล้ว");
                break;
              case "Cannot receive data as specified. The problem may be caused by the GPS signal of the device or the Internet signal is disrupted or MQTT server is error. Please try to reconnect.":
                setTextBody("ไม่พบ remote ID กรุณาลองใหม่อีกครั้ง");
                break;
              case "Please turn off the remote ID":
                setTextBody("กรุณาปิด remote ID และลองใหม่อีกครั้ง");
                break;
              case 'Attempt to read property "connect_status" on null':
                setTextBody("ไม่พบ serial number ในฐานข้อมูล");
                break;
              default:
                setTextBody("เกิดข้อผิดพลาด");
                console.log(error);
            }
            setModalToggle({ ...modalToggle, modalErr: true });
          })
      : setcheckopenRID(true);
    AuthServiceV2.registerremote(remoteid_name, remoteid_sn, "มก.", 5)
      .then((response) => {
        if (response.data.status === "error") {
          console.log(response.data.error_description);
          setConnecterror(true);
          if (response.data.error_description === "Remote ID already connected")
            setDataerror("RID มีอยู่ในระบบแล้ว");
          else if (
            response.data.error_description ===
            'Attempt to read property "connect_status" on null'
          ) {
            setDataerror("กรุณากรอก Serial Number ให้ถูกต้อง");
          } else {
            setDataerror("ตรวจสอบการเชื่อมต่อ RID ");
          }
        } else {
          setRemote_man(response.data.rid_manufacturer);
          // setWaitconnect(true);
          //setcheckopenRID(true);
          console.log(response);
          setSpinners(true);
          const connectdata = AuthServiceV2.TestConnectionRID(
            response.data.connection_token,
            0
          );
          console.log(connectdata.data);
          if (connectdata != null) {
            connectdata
              .then((res) => {
                console.log(res);

                // setcheckopenRID(true);

                setSpinners(false);

                setConnectiontoregis(response.data.connection_token);
                // if (res.data.registration_token) {
                //   setDatatoregis(res.data.registration_token);
                // }
              })
              .catch((err) => {
                setcheckopenRID(false);
                switch (err) {
                  case "Remote ID already connected":
                    setTextBody("Remote ID มีผู้ครอบครองแล้ว");
                    break;
                  case "Cannot receive data as specified. The problem may be caused by the GPS signal of the device or the Internet signal is disrupted or MQTT server is error. Please try to reconnect.":
                    setTextBody("ไม่พบ remote ID กรุณาลองใหม่อีกครั้ง");
                    break;
                  case "Please turn off the remote ID":
                    setTextBody("กรุณาปิด remote ID และลองใหม่อีกครั้ง");
                    break;
                  case 'Attempt to read property "connect_status" on null':
                    setTextBody("ไม่พบ serial number ในฐานข้อมูล");
                    break;
                  default:
                    setTextBody("เกิดข้อผิดพลาด");
                    console.log(err);
                }
                setModalToggle({ ...modalToggle, modalErr: true });

                // setDataerror("ไม่พบสัญญาณ  RID กรุณาลองใหม่อีกครั้ง");
                // setConnecterror(true);
              });
          }
        }

        //setUpdatedatasuc(true);
      })
      .catch((error) => {
        setcheckopenRID(false);
        switch (error) {
          case "Remote ID already connected":
            setTextBody("Remote ID มีผู้ครอบครองแล้ว");
            break;
          case "Cannot receive data as specified. The problem may be caused by the GPS signal of the device or the Internet signal is disrupted or MQTT server is error. Please try to reconnect.":
            setTextBody("ไม่พบ remote ID กรุณาลองใหม่อีกครั้ง");
            break;
          case "Please turn off the remote ID":
            setTextBody("กรุณาปิด remote ID และลองใหม่อีกครั้ง");
            break;
          case 'Attempt to read property "connect_status" on null':
            setTextBody("ไม่พบ serial number ในฐานข้อมูล");
            break;
          default:
            console.log(error);
            setTextBody("เกิดข้อผิดพลาด");
        }
        setModalToggle({ ...modalToggle, modalErr: true });
      });
  };
  const regisrid = () => {
    console.log(selectRID);
    setDatatoregis(undefined);
    setConnecterror(false);
    setcheckopenRID(false);
    setWaitconnect(true);
    setChecktime((prev) => !prev);

    setUpdatedata(false);
    const connectdata = AuthServiceV2.TestConnectionRID(connectiontoregis, 1);
    console.log(connectdata.data);
    if (connectdata != null) {
      connectdata
        .then((res) => {
          console.log(res);
          if (res.data.registration_token) {
            setDatatoregis(res.data.registration_token);
          }
          // setWaitconnect(false)
          // const savedata = AuthServiceV2.RegisStockRemoteID(res)
          // if(savedata != null){
          //   savedata.then((res)=>{
          //     console.log(res)
          //   }).catch((err)=>{
          //     setTextBody(err);
          //     setModalToggle({ ...modalToggle, modalErr: true });
          //   })
          // }
        })
        .catch((error) => {
          switch (error) {
            case "Remote ID already connected":
              setTextBody("Remote ID มีผู้ครอบครองแล้ว");
              break;
            case "Cannot receive data as specified. The problem may be caused by the GPS signal of the device or the Internet signal is disrupted or MQTT server is error. Please try to reconnect.":
              setTextBody("ไม่พบ remote ID กรุณาลองใหม่อีกครั้ง");
              break;
            case "Please turn off the remote ID":
              setTextBody("กรุณาปิด remote ID และลองใหม่อีกครั้ง");
              break;
            case 'Attempt to read property "connect_status" on null':
              setTextBody("ไม่พบ serial number ในฐานข้อมูล");
              break;
            default:
              console.log(error);
              setTextBody("เกิดข้อผิดพลาด");
          }
          setModalToggle({ ...modalToggle, modalErr: true });
          setCounttime(10)
          setChecktime(false)
          // setDataerror("ไม่พบสัญญาณ  RID กรุณาลองใหม่อีกครั้ง");
          // setConnecterror(true);
          setWaitconnect(false);

          // if (
          //   err.response.data.error_description ===
          //   "Cannot receive data as specified. The problem may be caused by the GPS signal of the device or the Internet signal is disrupted or MQTT server is error. Please try to reconnect."
          // )
          //   setDataerror("ไม่พบสัญญาณ  RID กรุณาลองใหม่อีกครั้ง");
          // else {
          //   setDataerror("กรุณาลองใหม่อีกครั้ง");
          // }
        });
    }
  };
  const next = () => {
    setShow(false);
    setSenddata(false);
    setUpdatedata(false);
    Navigate("/user/drone/statusDrone");
  };
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    //console.log(droneid_regis);
    //console.log(form.checkValidity());
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      setUpdatedata(true);
      event.preventDefault();
      // if (droneid_regis == 0) {
      //   event.preventDefault();
      //   event.stopPropagation();
      // } else {

      // }
    }
    setValidated(true);
  };

  return (
    <div className="container-main">
      <div
        style={{
          fontFamily: "Kanit",
          color: "black",
          marginTop: "15px",
          padding: "0px 50px",
        }}
      >
        <h2 className="header-main">{t('regisRID.main')}</h2>
        &nbsp;
        <div>
          
          <div>
            {/* <Button
              className="btn-switching"
              style={{
                border: selectRID ? "5px inset #0096C7" : "1px solid #c8c8c8",
                background: selectRID
                  ? "linear-gradient(101.27deg, #023E8A 0%, #0096C7 100%)"
                  : "#c8c8c8",
                opacity: 1,
              }}
              onClick={() => {
                setSelectRID(!selectRID);
                setRemote_man("");
              }}
              disabled={selectRID}
            >
              <span>Built-In Remote ID</span>
            </Button>

            <Button
              className="btn-switching"
              style={{
                border: selectRID ? "1px solid #c8c8c8" : "5px inset #0096C7",
                background: selectRID
                  ? "#c8c8c8"
                  : "linear-gradient(101.27deg, #023E8A 0%, #0096C7 100%)",
                opacity: 1,
              }}
              onClick={() => setSelectRID(!selectRID)}
              disabled={!selectRID}
            >
              <span>Add-On Remote ID</span>
            </Button> */}
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Row
                className="mb-3"
                style={{
                  marginTop: "40px",
                  marginLeft: "auto",
                  marginRight: "auto",
                  fontSize: "28px",
                  width: "100%",
                  padding: "0px 20px",
                }}
              >
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen" style={{ fontSize: "24px" }}>
                    {t('regisRID.ridname')}
                    <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    //placeholder="10059199720"
                    //disabled
                    className="form-input-lg"
                    onChange={(e) => {
                      setRemote_name(e.target.value);
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen" style={{ fontSize: "24px" }}>
                    {t('regisRID.ridserial')}
                    <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    //placeholder="10059199720"
                    //disabled
                    className="form-input-lg"
                    onChange={(e) => {
                      setRemote_sn(e.target.value);
                    }}
                  />
                </Form.Group>
                {selectRID === true ? (
                  ""
                ) : (
                  // <Form.Group as={Col} md="6">
                  //   <Form.Label
                  //     className="font-cen"
                  //     style={{ fontSize: "24px" }}
                  //   >
                  //     Remote ID manufacture
                  //     <span style={{ color: "red" }}>*</span>
                  //   </Form.Label>
                  //   <Form.Control
                  //     required
                  //     type="text"
                  //     //placeholder=""
                  //     disabled
                  //     className="form-input-lg"
                  //     value={remoteid_man}
                  //     onChange={(e) => {
                  //       setRemote_man(e.target.value);
                  //     }}
                  //   />
                  // </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label
                      className="font-cen"
                      style={{ fontSize: "24px" }}
                    >
                      {t('regisRID.ridmanufac')}
                      <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Form.Select
                      required
                      className="form-input-lg"
                      onChange={(e) => {
                        setRemote_man(e.target.value);
                      }}
                    >
                      <option value="" hidden>
                        Select an option
                      </option>
                      <option value="Gistda">Gistda</option>
                    </Form.Select>
                    {/* <Form.Control
                      required
                      type="text"
                      //placeholder="10059199720"
                      //disabled
                      className="form-input-lg"
                      onChange={(e) => {
                        setRemote_man(e.target.value);
                      }}
                    /> */}
                  </Form.Group>
                )}
              </Row>
              <div style={{ display: "flex", marginLeft: "35px" }}>
                <Button
                  type="submit"
                  className="custom-btn btnSave"
                  style={{
                    width: "300px",
                    height: "87px",
                    fontSize: "31px",
                    marginTop: "45px",
                    marginRight: "50px",
                  }}
                >
                  {t('regisRID.addrid')}
                </Button>
              </div>
              {selectRID === true ? (
                <Modal
                  show={updatedata}
                  onHide={handleClose}
                  className="font-cen"
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>บันทึกข้อมูล</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>เพิ่ม Remote ID</Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                      ยกเลิก
                    </Button>
                    <Button variant="primary" onClick={handleUpdatesuc}>
                      บันทึก
                    </Button>
                  </Modal.Footer>
                </Modal>
              ) : (
                <Modal
                  show={updatedata}
                  onHide={handleClose}
                  className="font-cen"
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>เชื่อมต่อ Remote ID</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    กรุณาปิด Remote ID ก่อนทำการกดยืนยัน
                    <br />
                    <span style={{ color: "red" }}>
                      ***สำหรับ Broadcast Remote ID กรุณาลบข้อมูลใน App GISTDA
                      Remote ID ด้วยนะคะ
                    </span>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                      ยกเลิก
                    </Button>
                    <Button variant="primary" onClick={handleUpdatesuc}>
                      ยืนยัน
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
              <Modal
                show={checkopenRID}
                onHide={() => {
                  setcheckopenRID(false);
                }}
                className="font-cen"
                centered
                backdrop="static"
                keyboard={false}
              >
                {spinners === true ? (
                  ""
                ) : (
                  <Modal.Header closeButton>
                    <Modal.Title>เชื่อมต่อ Remote ID </Modal.Title>
                  </Modal.Header>
                )}

                {spinners === true ? (
                  <div className="form-section">
                    <div
                      className="loading-container"
                      style={{ height: "20px" }}
                    >
                      {" "}
                      <Spinner
                        animation="border"
                        variant="secondary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </div>
                  </div>
                ) : (
                  <Modal.Body>
                    <div>กรุณาเปิดเครื่อง Remote ID เพื่อเชื่อมต่อ</div>
                    <br />
                    <span style={{ color: "red" }}>
                      ***สำหรับ Broadcast Remote ID กรุณาส่งข้อมูลเข้า UTM ผ่าน
                      App GISTDA Remote ID
                    </span>
                  </Modal.Body>
                )}

                {spinners === true ? (
                  ""
                ) : (
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => {
                        setcheckopenRID(false);
                      }}
                    >
                      ยกเลิก
                    </Button>
                    <Button variant="primary" onClick={()=>handleRegistremot()}>
                      ยืนยัน
                    </Button>
                  </Modal.Footer>
                )}
              </Modal>

              <Modal
                show={waitconnect}
                onHide={() => setWaitconnect(false)}
                className="font-cen"
                centered
                backdrop="static"
                keyboard={false}
              >
                <Modal.Header closeButton>
                  {datatoregis === undefined ? (
                    <Modal.Title>เชื่อมต่อ Remote ID </Modal.Title>
                  ) : (
                    <Modal.Title>ยืนยันการครอบครอง Remote ID </Modal.Title>
                  )}
                </Modal.Header>
                <Modal.Body>
                  {datatoregis === undefined ? (
                    <>
                      กำลังเชื่อมต่อกรุณารอสักครู่ ...{" "}
                      <span className="spinner-border spinner-border"></span>
                      <div>เหลือเวลา: {formatTime(counttime)}</div>
                    </>
                  ) : (
                    <>
                      <span style={{ color: "green" }}>
                        ยืนยันการครอบครอง remote ID สำเร็จแล้ว
                        <br />
                        คุณต้องการบันทึกผลการครอบครองหรือไม่ ?
                      </span>
                    </>
                  )}
                </Modal.Body>
                {datatoregis != undefined ? (
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setWaitconnect(false)}
                    >
                      ยกเลิก
                    </Button>
                    <Button variant="primary" onClick={WaitConnectRID}>
                      ยืนยัน
                    </Button>
                  </Modal.Footer>
                ) : (
                  ""
                )}
              </Modal>
              <Static_modal
                modalwaiting={modalToggle.modalwait}
                modalErr={modalToggle.modalErr}
                modalSuccess={modalToggle.modalSuccess}
                modalDenied={modalToggle.modalDenied}
                textBody={textBody}
                getHandle={handleClose_Modal}
              />
              <Modal
                show={updatedatasuc}
                onHide={handleClose}
                className="font-cen"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>บันทึกข้อมูลสำเร็จ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <img
                    src={check}
                    style={{
                      width: "100px",
                      height: "100px",
                      padding: "3%",
                      marginLeft: "180px",
                    }}
                  />
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handlesuc}>
                    สถานะ
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={() => {
                      setUpdatedata(false);
                      window.location.reload(false);
                    }}
                  >
                    เพิ่ม Remote ID อื่นเพิ่มเติม
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={() => {
                      Navigate("/home");
                      window.location.reload(false);
                    }}
                  >
                    กลับสู่หน้าหลัก
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal
                show={show}
                onHide={handleClose}
                className="font-cen"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>นำส่งข้อมูลการขอขึ้นทะเบียน</Modal.Title>
                </Modal.Header>
                <Modal.Body>ข้อมูลส่วนตัวจะถูกบันทึกใหม่</Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    ยกเลิก
                  </Button>
                  <Button variant="primary" onClick={handleSendsuc}>
                    นำส่งข้อมูล
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal
                show={senddata}
                onHide={handleclosereload}
                className="font-cen"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>นำส่งข้อมูลสำเร็จ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <img
                    src={check}
                    style={{
                      width: "100px",
                      height: "100px",
                      padding: "3%",
                      marginLeft: "180px",
                    }}
                  />
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleclosereload}>
                    ปิด
                  </Button>
                  <Button variant="primary" onClick={next}>
                    ดูสถานะ
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal
                show={show}
                onHide={handleClose}
                className="font-cen"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>นำส่งข้อมูลการขอขึ้นทะเบียน</Modal.Title>
                </Modal.Header>
                <Modal.Body>ข้อมูลส่วนตัวจะถูกบันทึกใหม่</Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    ยกเลิก
                  </Button>
                  <Button variant="primary" onClick={handleSendsuc}>
                    นำส่งข้อมูล
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal
                show={connecterror}
                onHide={() => setConnecterror(false)}
                className="font-cen"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>นำส่งข้อมูลไม่สำเร็จ</Modal.Title>
                </Modal.Header>
                <Modal.Body>{dataerror}</Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() => setConnecterror(false)}
                  >
                    ปิด
                  </Button>
                </Modal.Footer>
              </Modal>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Regisremote;
